import React from "react";
import CloudList from "./ListWidget";
import { promiseTrackerHoc } from "react-promise-tracker";
import { ListScripts } from "./Lists/listScripts";

const ListWidgetWithSpinner = (props) => {
   const { value, role, setWidgetHeights } = props;
   const basicSerieSettings = ListScripts.getBasicSerieSettings();
   if (
      (value.listWidgetSeries[0] &&
         value.listWidgetSeries[0].listWidgetSerieSettings &&
         value.listWidgetSeries[0].listWidgetSerieSettings.length === 0) ||
      (value.listWidgetSeries[0] && value.listWidgetSeries[0].itemsPerPage === null) ||
      (value.listWidgetSeries[0] && value.listWidgetSeries[0].itemsPerPage === undefined)
   ) {
      value.listWidgetSeries[0] = {
         columnProperties: value.listWidgetSeries[0].columnProperties,
         listWidgetSerieKey: 0,
         id: value.listWidgetSeries[0].id,
         name: value.listWidgetSeries[0].name,
         query: "Click here to change query",
         listId: value.listWidgetSeries[0].listId,
         itemsPerPage: 10,
         listWidgetSerieSettings: basicSerieSettings,
      };
   } else if (value.listWidgetSeries && value.listWidgetSeries.length === 0) {
      value.listWidgetSeries[0] = {
         listWidgetSerieKey: 0,
         id: 10000,
         name: "List",
         query: "Click here to change query",
         listId: 37,
         itemsPerPage: 10,
         listWidgetSerieSettings: basicSerieSettings,
      };
   }

   return (
      <CloudList
         role={role}
         name={value.name}
         widgetId={value.id}
         xs={value.xsWidth}
         sm={value.smWidth}
         md={value.mdWidth}
         lg={value.lgWidth}
         xl={value.xlWidth}
         priority={value.priority}
         showListName={value.showListName}
         listWidgetSeries={value.listWidgetSeries}
         clickedRow={value.clickedRow}
         backgroundColourHex={value.backgroundColourHex}
         localizationFieldName={value.mapLocalizationFieldName}
         mapClickFilterColName={value.mapClickFilterColName}
         defaultZoomLevel={value.mapDefaultZoomLevel}
         viewListSerie={value.mapViewListSerie}
         mapListSerie={value.mapListSerie}
         mapIndependentSerie={value.mapIndependentSerie}
         mapPointColName={value.mapPointColName}
         mapDistanceColName={value.mapDistanceColName}
         mapAddressColName={value.mapAddressColName}
         showMap={value?.showMap}
         showPlacefinder={value?.showPlacefinder}
         filterByLocation={value.filterByLocation}
         distanceToFilter={value.distanceToFilter}
         maxDistanceToFilter={value.maxDistanceToFilter}
         setDistanceColumnHidden={value.setDistanceColumnHidden}
         showChatButton={value.showChatButton}
         showUrlButton={value.showUrlButton}
         ulrButtonTitle={value.ulrButtonTitle}
         urlColumn={value.urlColumn}
         chatUsersColumnTechNames={value.chatUsersColumnTechNames}
         title={value.title}
         subTitle={value.subTitle}
         chatButtonTitle={value.chatButtonTitle}
         setWidgetHeights={setWidgetHeights}
      />
   );
};

export const ListWidget = promiseTrackerHoc(ListWidgetWithSpinner);
